var map = {
	"./abb-color.svg": 1764,
	"./afb-color.svg": 1765,
	"./afb.svg": 1766,
	"./agro-color.svg": 1767,
	"./alb-color.svg": 1768,
	"./alb.svg": 1769,
	"./amb-color.svg": 1770,
	"./amb.svg": 1771,
	"./bbbaidja-color.svg": 1772,
	"./bbbaidjaxxx-color.svg": 1773,
	"./bdinidjaxxx-color.svg": 1774,
	"./bimb-color.svg": 1775,
	"./bimb.svg": 1776,
	"./bkr-color.svg": 1777,
	"./bkr.svg": 1778,
	"./bmriidja-color.svg": 1779,
	"./bniaidja-color.svg": 1780,
	"./bninidja-color.svg": 1781,
	"./bninidjaxxx-color.svg": 1782,
	"./boc-color.svg": 1783,
	"./bpay-color.svg": 1784,
	"./brinidja002-color.svg": 1785,
	"./bsmdidjaxxx-color.svg": 1786,
	"./bsn-color.svg": 1787,
	"./bsn.svg": 1788,
	"./btanidjaxxx-color.svg": 1789,
	"./cenaidja-color.svg": 1790,
	"./cenaidjaxxx-color.svg": 1791,
	"./cimb-color.svg": 1792,
	"./cimb.svg": 1793,
	"./citi-color.svg": 1794,
	"./citi.svg": 1795,
	"./default-bank-icon-color.png": 1796,
	"./default-bank-icon.png": 1797,
	"./gxbank-color.svg": 1798,
	"./hlb-color.svg": 1799,
	"./hlb.svg": 1800,
	"./hsbc-color.svg": 1801,
	"./hsbc.svg": 1802,
	"./ibbkidjaxxx-color.svg": 1803,
	"./kfh-color.svg": 1804,
	"./kwh-color.svg": 1805,
	"./kwh.svg": 1806,
	"./mbb-color.svg": 1807,
	"./mbb.svg": 1808,
	"./muamalat-color.svg": 1809,
	"./nispidjaxxx-color.svg": 1810,
	"./ocbc-color.svg": 1811,
	"./ocbc.svg": 1812,
	"./pbb-color.svg": 1813,
	"./pbb.svg": 1814,
	"./pinbidja-color.svg": 1815,
	"./raykat-color.svg": 1816,
	"./rhb-b.svg": 1817,
	"./rhb-color-b.svg": 1818,
	"./rhb-color.svg": 1819,
	"./rhb.svg": 1820,
	"./scb-color.svg": 1821,
	"./scb.svg": 1822,
	"./tng-color.svg": 1823,
	"./uob-color.svg": 1824,
	"./uob.svg": 1825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;